import { KAAP_API_TOKEN_SECRET_KEY, useKaapAzureToken } from '../hooks';

export { KAAP_API_TOKEN_SECRET_KEY };

/**
 * Silently acquires an Azure token scoped to the KaaP API and stores it under
 * `secrets.KAAP_API_TOKEN`. Renders nothing — used as a hidden field by the
 * delete-tenant template. (Create/edit fold this into `KaapTenantForm`.)
 */
export const KaapAzureToken = () => {
  useKaapAzureToken();
  return null;
};
